import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utils/AxiosConfig";

let scriptPromise;
let publicConfigPromise;

const loadScript = () => {
  if (window.TabbyPromo) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://checkout.tabby.ai/tabby-promo.js";
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    }).catch((error) => { scriptPromise = null; throw error; });
  }
  return scriptPromise;
};

const loadPublicConfig = () => {
  if (!publicConfigPromise) {
    publicConfigPromise = axiosInstance.get("/tabby/public-config")
      .then(({ data }) => data)
      .catch((error) => { publicConfigPromise = null; throw error; });
  }
  return publicConfigPromise;
};

function TabbyPromo({ price, source }) {
  const containerRef = useRef(null);
  const [config, setConfig] = useState(null);
  const formattedPrice = Number(price).toFixed(2);

  useEffect(() => {
    let active = true;
    loadPublicConfig().then((value) => { if (active) setConfig(value); }).catch(() => {});
    return () => { active = false; };
  }, []);

  useEffect(() => {
    if (!config?.available || !config.public_key || !config.merchant_code ||
        !Number.isFinite(Number(price)) || Number(price) <= 0) return undefined;
    let active = true;
    loadScript().then(() => {
      if (!active || !containerRef.current || !window.TabbyPromo) return;
      containerRef.current.replaceChildren();
      new window.TabbyPromo({
        selector: "#elumia-tabby-promo",
        currency: "AED",
        price: formattedPrice,
        lang: "en",
        source,
        shouldInheritBg: true,
        publicKey: config.public_key,
        merchantCode: config.merchant_code,
      });
    }).catch(() => {});
    return () => { active = false; };
  }, [config, formattedPrice, price, source]);

  if (!config?.available || !Number.isFinite(Number(price)) || Number(price) <= 0) return null;
  return <div id="elumia-tabby-promo" ref={containerRef} style={{ maxWidth: "100%" }} />;
}

export default TabbyPromo;
